<template>
    <div class="my-2">
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-btn v-if="xeroAuth&&selectedOrganisation" round color="primary" class="white--text" @click="addContactItem()">Add Contact Link</v-btn>
            <v-btn round color="primary" class="white--text" v-if="xeroUrl" :href="xeroUrl">Connect to Xero</v-btn>
        </v-toolbar>
        <v-data-table :items="xeroAccountContacts" :headers="headers" :key="key">

        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-layout justify-center align-center>
              <v-icon @click="editContactItem(props.item)">edit</v-icon>
              <v-icon @click="deleteContactItem(props.item)">delete</v-icon>

            </v-layout>
          </td>
          <td class="text-xs-center">{{props.item.customerOrganisation.name}}</td>
          <td class="text-xs-center">{{props.item.xeroContactName}}</td>
        </template>
        </v-data-table>
        <v-dialog v-model="addItemModal" persistent width="750px">
            <v-card flat color="white">
                <v-toolbar flat color="primary">
                    <h3 class="title white--text">{{item.modalType}} Contact Link</h3>
                    <v-spacer></v-spacer>
                    <v-btn flat color="white" @click="saveLink()" v-if="item.modalType=='Add'&&item.customerOrganisationId&&item.xeroContact != null">Add Link</v-btn>
                    <v-btn flat color="white" @click="updateLink()" v-else-if="item.modalType=='Edit'&&item.customerOrganisationId&&item.xeroContact != null">Update Link</v-btn>
                    <v-btn flat color="white" @click="addItemModal=false, item={}">X</v-btn>
                </v-toolbar>
                <v-card-text ma-1>
                    <v-layout justify-center align-center wrap>
                        <v-flex xs4 mx-1>
                            <v-autocomplete :items="allOrganisations" item-text="name" item-value="id" v-model="item.customerOrganisationId" label='Glue Organisation'></v-autocomplete>
                        </v-flex>
                        <v-flex xs4 mx-1>
                            <v-autocomplete :items="xeroContacts" item-text="name" return-object v-model="item.xeroContact" label='Xero Organisation'></v-autocomplete>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
         <v-dialog v-model="selectOrgModal" persistent width="750px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Organisation Connection:</h3>
        </v-toolbar>
        <v-card-text ma-1>
          <v-layout justify-center>
            <v-flex xs4 ma-1>
            <v-select :items="xeroOrganisations" item-text="orgData.name" item-value="orgData.organisationId" label="Select an Organisation" return-object v-model="selectedOrganisation"></v-select>
          </v-flex>
          </v-layout>
          
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn v-if="selectedOrganisation" round color="primary" class="white--text" @click="getRequiredData()">Done</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import Api from '../services/Api'
export default {
    data(){
        return {
            addItemModal: false,
            allOrganisations: [],
            item: {},
            key: 0,
            selectedOrganisation: null,
            selectOrgModal: false,
            xeroAccountContacts: [],
            xeroAuth: null,
            xeroContacts: [],
            xeroOrganisations: [],
            xeroUrl: null,
            headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Organisation",
          align: "center",
          value: "customerOrganisation.name"
        },
        {
          text: "Xero Contact",
          align: "center",
          value: "xeroContactName"
        }
        ]
        }
    },
    created(){
        this.initialize()
    },
    methods: {
        initialize(){
          this.getLinkedAccounts()
            this.getXeroLoginUrl()
        },
        addContactItem(){
            if (this.authCreate(this.$store.state.currentRoute)){
                this.item={
                    modalType: 'Add',
                    xeroContact: null
                }
                this.addItemModal=true
            }
        }, 
        editContactItem(item){
            if (this.authUpdate(this.$store.state.currentRoute)){
                this.item=item
                this.item.modalType='Edit'
                this.item.xeroContact = {contactId: this.item.xeroContactId, name: this.item.xeroContactName}
                this.addItemModal=true
            }
        }, 
        deleteContactItem(item){
            if (this.authDelete(this.$store.state.currentRoute)){
                confirm('Are you sure you want to remove this link?')&&
                Api().put('/xeroAccountContact/'+item.id,{isActive: false, isDeleted: true})
                .then(response=>{
                  this.getLinkedAccounts()
                })
            }
        }, 
        getXeroLoginUrl(){
      // debugger
      Api().get('/xero/authenticate').then(response=>{
        if(response.data.url){
        this.xeroUrl = response.data.url
        if(this.$route.query.code){
          this.getXeroTokens(this.xeroUrl)
      }} else if(response.data.tokenSet){
        this.xeroAuth = response.data.tokenSet
        this.getXeroOrganisations()
      }
      })
    },
    getXeroTokens(){
      Api().get('/xero/callback', {
        params:  this.$route.query
      }).then(response=>{
        if(response.data.tokenSet){
          // console.log(response.data)
          this.xeroAuth = response.data.tokenSet
          // console.log(this.xeroAuth)
          this.getXeroOrganisations()
        }
      })
    },
    getXeroOrganisations(){
        Api().get('/xero/getOrganisations').then(response=>{
        this.xeroOrganisations = response.data
        if(this.xeroOrganisations.length>1){
        this.selectOrgModal= true
        } else {
          this.selectedOrganisation = this.xeroOrganisations[0]
          this.getRequiredData()
        }
      })
    },
    getRequiredData(){
        this.getXeroContacts(this.selectedOrganisation.tenantId)
        this.getGlueOrganisations()
        this.selectOrgModal = false
    },
    getGlueOrganisations(){
        Api().get('/organisation/subOrganisations/all').then(response=>{
            this.allOrganisations=response.data
            if(this.allOrganisations.length == 0){
              this.getVirtualIspList()
            }
        })
    },
    getVirtualIspList(){
      Api().get('/virtualIsp')
      .then(response=>{
        this.allOrganisations = response.data.map(x=>x.virtualIsp)
      })
    },
    getXeroContacts(tenantId){
      Api().get('/xero/contacts/'+tenantId).then(response=>{
        if(response.data.body.contacts){
        this.xeroContacts = response.data.body.contacts
        }
        
      })
    },
    getLinkedAccounts(tenantId){
      Api().get('/xeroAccountContact').then(response=>{
        this.xeroAccountContacts = response.data
        this.key += 1 
      })
    },
    saveLink(){
        console.log(this.item)
        let obj = {
          customerOrganisationId: this.item.customerOrganisationId,
          xeroContactName: this.item.xeroContact.name,
          xeroContactId: this.item.xeroContact.contactID
        }
        Api().post('/xeroAccountContact', obj)
        .then(response=>{
          this.getLinkedAccounts()
          this.addItemModal=false
          this.item={}
        })
    },
    updateLink(){
        console.log(this.item)
        let obj = {
          customerOrganisationId: this.item.customerOrganisationId,
          xeroContactName: this.item.xeroContact.name,
          xeroContactId: this.item.xeroContact.contactID
        }
        Api().put('/xeroAccountContact/'+this.item.id, obj)
        .then(response=>{
          this.getLinkedAccounts()
          this.addItemModal=false
          this.item={}
        })
    }
    }
}
</script>